import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import ProjectCard from "./ProjectCards";
import BlogCard from "./BlogsCards";
import Particle from "../Particle";
import "../../style.css";
import "bootstrap/dist/css/bootstrap.min.css";

import simon from "../../Assets/Projects/simon.png";
import magic from "../../Assets/Projects/magic.jpg";
import phoenix from "../../Assets/Projects/phoenix.png";
import hp from "../../Assets/Projects/hp.png";
import galga from "../../Assets/Projects/galga.png";

function Projects() {
  return (
    <Container fluid className="project-section">
      <Particle />
      <Container>
        <h1 className="project-heading">
          My Recent <strong className="purple">Works </strong>
        </h1>
        <p style={{ color: "white" }}>
          Projects I have worked with !!.
        </p>
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={simon}
              isBlog={false}
              title="Facial Recognition based Attendance System"
              description="I developed a system to detect a person and punch his/her attendance automatically whenever he/she passes through the main gate. The system I tested could easily generalize between 25 people in different lighting conditions."
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={magic}
              isBlog={false}
              title="Movie Recommendation System"
              description="This was my final year project. The project uses content-based filtering for recommending movies to users. The UI of the project is still under development. I used Movielens dataset to perform my project."
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={galga}
              isBlog={false}
              title="Object Detection Using YOLO"
              description="Made this amazing project when I was in my pre-final year and was introduced to the basic concepts of deep learning. I used YOLO to perform object detection and I referred to online resources while making the project. "
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={phoenix}
              isBlog={false}
              title="Face Mask Detector"
              description="During the tough times of Covid-19, I developed a deep learning based project which detects whether a person is wearing mask or not. The project shows detection accuracy along with assigned label."
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={hp}
              isBlog={false}
              title="Personal Portfolio Website"
              description="Made a website showing my personal portfolio and details. Used online repos. as I am still a beginner in web-development. The website is based on ReactJS and is hosted on Netlify."
            />
          </Col>
        </Row>
      </Container>
    </Container>
  );
}

export default Projects;
